<div class="edit-questions card rounded" *ngIf="questionAnswerArr">
  <ng-container *ngFor="let questionAnswer of questionAnswerArr; let idxQA = index">
    <div class="answer-form mb-3">
      <ng-container [ngSwitch]="questionAnswer.question.type">
        <ng-container *ngIf="!toggleEdit">
          <label class="question-text-label" for="{{ idxQA }}">{{ questionAnswer.question.value }}</label>
        </ng-container>
        <div
          class="answers"
          [ngClass]="{
            'form-floating':
              toggleEdit &&
              (questionAnswer.question.type == TYPE_QUESTION.TextBox || questionAnswer.question.type == TYPE_QUESTION.DropDown),
          }"
          [formGroup]="questionAnswer.answerForm"
        >
          <!-- DROPDOWN -->
          <ng-container *ngSwitchCase="TYPE_QUESTION.DropDown">
            <select
              [ngClass]="{
                'disappear-appearance': questionAnswer?.answerForm.controls['arr'].disabled,
              }"
              formArrayName="arr"
              class="form-select cursor-pointer rounded"
              (change)="onAnswerChange(idxQA, $event, TYPE_QUESTION.DropDown)"
              [disabled]="questionAnswer?.answerForm.controls['arr'].disabled"
              [id]="idxQA"
            >
              <option selected disabled hidden>-- Please select answer --</option>
              <option
                class="answer-dropdown-option"
                *ngFor="let answer of questionAnswer?.answerForm.controls['arr'].controls; let idxAnswer = index"
                [formControlName]="idxAnswer"
                ngDefaultControl
                [selected]="answer.value.Selected"
              >
                {{ answer.value.Answer }}
              </option>
            </select>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <ng-container
              class="answer-textbox"
              formArrayName="arr"
              *ngFor="let select of questionAnswer?.answerForm.controls['arr'].controls; let idxAnswer = index"
            >
              <input
                type="text"
                class="answer-input form-control"
                [id]="idxAnswer"
                [value]="select.value.Answer"
                [disabled]="questionAnswer?.answerForm.controls['arr'].disabled"
                (input)="onAnswerChange(idxQA, $event, TYPE_QUESTION.TextBox)"
                placeholder=""
              />
            </ng-container>
          </ng-container>
          <ng-container *ngIf="toggleEdit">
            <label
              class="question-text-label"
              [ngClass]="{
                'padding-top-label':
                  questionAnswer.question.type == TYPE_QUESTION.TextBox || questionAnswer.question.type == TYPE_QUESTION.DropDown,
              }"
              for="{{ idxQA }}"
              >{{ questionAnswer.question.value }}</label
            >
          </ng-container>

          <!-- RADIO -->
          <ng-container *ngSwitchCase="TYPE_QUESTION.Radio">
            <div
              formArrayName="arr"
              class="answer-radio"
              *ngFor="let groupRadio of questionAnswer?.answerForm.controls['arr'].controls; let idxAnswer = index"
            >
              <input
                (change)="onAnswerChange(idxQA, $event, TYPE_QUESTION.Radio)"
                [value]="groupRadio.value"
                name="radio-btn"
                [id]="idxAnswer"
                type="radio"
                class="answer-radio-input"
                [disabled]="questionAnswer?.answerForm.controls['arr'].disabled"
                [checked]="groupRadio.value.Selected"
              />
              <label class="answer-radio-label"> {{ groupRadio.value.Answer }}</label>
            </div>
          </ng-container>
          <!-- CHECKBOX -->
          <ng-container *ngSwitchCase="TYPE_QUESTION.MultiSelect">
            <form
              class="answer-checkbox"
              formArrayName="arr"
              *ngFor="let select of questionAnswer?.answerForm.controls['arr'].controls; let idxAnswer = index"
            >
              <input
                type="checkbox"
                class="answer-checkbox-input"
                name="checkbox"
                [id]="idxAnswer"
                [disabled]="questionAnswer?.answerForm.controls['arr'].disabled"
                [checked]="select.value.Selected"
                (change)="onAnswerChange(idxQA, $event, TYPE_QUESTION.MultiSelect)"
              />
              <label [for]="idxAnswer" class="answer-checkbox-label"> {{ select.value.Answer }}</label>
            </form>
          </ng-container>
          <!-- TEXTBOX -->
        </div>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="isEditable">
    <ng-container *ngIf="!toggleEdit; else editTemplate">
      <button class="btn edit" (click)="changeToggleEditValue()">{{ 'edit.question.edit' | translate }}</button>
    </ng-container>
  </ng-container>

  <ng-template #editTemplate>
    <div class="wrap-btn">
      <button class="btn cancel" (click)="changeToggleEditValue(true)">{{ 'edit.question.cancel' | translate }}</button>
      <button class="btn save" (click)="onSave()">{{ 'edit.question.save' | translate }}</button>
    </div>
  </ng-template>
</div>
